// Copyright (c) 2016 Deere & Company

import {updateClaimModalMode, updateCreateClaimModalVisibility} from './create-claim-modal-visibility';
import actions from '../action-list';
import {createJdpClaim} from './validate-claim';
import {getUpdatedJdpClaim} from '../services/update-jdp-claim';
import {isActionResetFormValidation} from '../../../shared/services/claim-shared-helper';

export const updateSelectedAction = selectedAction =>

    (dispatch, getState) => {

        const updatedClaim = getUpdatedJdpClaim(getState().claims.jdp.claim, selectedAction);

        const updateModalVisibility = () => {

            updateClaimModalMode('CREATE')(dispatch);
            updateCreateClaimModalVisibility(true)(dispatch);

        };

        const updateIsEditable = () => {

            dispatch({
                type: actions.REVISE_CLAIM_JDP
            });

            dispatch({
                isEditable: true,
                type: actions.UPDATE_CLAIM_JDP_IS_EDITABLE
            });

        };

        if (isActionResetFormValidation(selectedAction.id)) {

            dispatch({
                type: actions.RESET_CLAIM_JDP_FORM_VALIDATION
            });

        }

        const selectedActionIdTypes = {
            CRT: updateModalVisibility,
            REVISE: updateIsEditable
        };

        const updateType = selectedActionIdTypes[selectedAction.id];

        return updateType ? updateType() : createJdpClaim(updatedClaim)(dispatch, getState);

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/action-creators/update-selected-action.js